import React from 'react';
import EyeIcon from '@tradera/tradera-ui/icons/eye.svg?jsx';

const QuickViewButton = ({ handleQuickViewClick }) => {
    return (
        <div
            className="d-none d-lg-flex quick-view-icon bg-primary rounded justify-content-center align-items-center"
            onClick={() => handleQuickViewClick()}>
            <EyeIcon className="icon icon-lg icon-white" />
        </div>
    );
};

export default QuickViewButton;



// WEBPACK FOOTER //
// ./src/EbaySweden.TouchWeb/static/script/components/item-card/quick-view-button.jsx